import React from 'react'
import PropTypes from 'prop-types'
import './TableSkeletonLoader.css'

const TableSkeletonLoader = ({rows = 5, rowHeight = 40, spacing = 12}) => {
  const rowIds = React.useMemo(
    () => Array.from({length: rows}, (_, idx) => `skeleton-${idx}`),
    [rows]
  )

  return (
    <div className="table-skeleton-wrapper">
      {rowIds.map(id => (
        <div
          key={id}
          data-testid="table-skeleton-line"
          className="table-skeleton-line"
          style={{
              height: `${rowHeight}px`, 
              marginBottom: `${spacing}px`,
            }}
          />
        ))}
    </div>
  )
}

TableSkeletonLoader.propTypes = {
  rows: PropTypes.number,
  rowHeight: PropTypes.number,
  spacing: PropTypes.number,
}

export default TableSkeletonLoader
